module.exports = __webpack_public_path__ + "img/ygz.50683019.svg";